'use strict';

// l-headerを取得
const header = document.querySelector('.l-header') as HTMLElement;

// l-headerの高さを取得して、カスタムプロパティに格納する
header.style.setProperty('--headerHeight', `${header.clientHeight}px`);

// l-headerButtonを取得
const headerButton = document.querySelector('.l-headerButton') as HTMLElement;

// l-headerNavigationを取得
const headerNavigation = document.querySelector(
  '.l-headerNavigation'
) as HTMLElement;

//　l-headerButtonをクリックしたら、onクラスを付与する
headerButton.addEventListener('click', () => {
  headerButton.classList.toggle('on');
  headerNavigation.classList.toggle('on');
  document.body.classList.toggle('fixed');
});
